import React from 'react';
import { hydrateRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import App from './App/App';
import { ConfigProvider } from './modules/ConfigProvider/ConfigProvider';
import type { ClientContext } from './types/types';

export default ({ config }: ClientContext) => {
  const routerProps: any = { basename: config.basePathName };

  hydrateRoot(
    document.getElementById('app') as Element,
    <ConfigProvider config={config}>
      <BrowserRouter {...routerProps}>
        <App />
      </BrowserRouter>
    </ConfigProvider>,
  );
};
